import login from "./login.json";
import navigation from "./navigation.json";
import services from "./services.json";

export default { navigation, services, login };
